import React from 'react';
import T from 'Components/Helpers/translate';

type Props = {
	metaKey: string;
	showAdvanced: boolean;
	onAdvanced: () => void;
};

const SupersearchFooter = ({ metaKey, showAdvanced, onAdvanced }: Props) => {
	if (!showAdvanced) {
		return null;
	}

	return (
		<div className="SupersearchFooter">
			<button type="button" className="SupersearchFooter__advanced" onClick={onAdvanced}>
				<span className="SupersearchFooter__key">{`${metaKey}↵`}</span>
				<span className="SupersearchFooter__label">{T('filters.advancedSearch')}</span>
			</button>
		</div>
	);
};

export default SupersearchFooter;
